import * as z from 'zod';

/**
 * The current user's granted UI permissions, as `accessApi.mine` derives them
 * from the feature map: every catalog key not denied (wildcards `*`, `orders.*` still match). Unknown strings are kept,
 * not rejected — a key the backend knows but this build doesn't is harmless
 * (nothing checks it), and failing the parse would lock the user out.
 */
export const grantedPermissionsSchema = z.object({
  permissions: z.array(z.string()),
});
export type GrantedPermissions = z.infer<typeof grantedPermissionsSchema>;
